import { OPEN_INVITE_POPUP, CLOSE_INVITE_POPUP } from "../actions";

export const initialState = {
	show: false,
	championship: null,
};

export type InviteState = typeof initialState;

export default function (state = initialState, action) {
	switch (action.type) {
		case OPEN_INVITE_POPUP: {
			return {
				show: true,
				championship: action.championship,
			};
		}

		case CLOSE_INVITE_POPUP: {
			return {
				...initialState,
				show: false,
			};
		}

		case "@@router/LOCATION_CHANGE": {
			return {
				...initialState,
				show: false,
			};
		}

		default:
			return state;
	}
}
